export default __webpack_public_path__ + "static/media/chevron-right-disabled.f72ffdc2.svg";